export const VALIDATION_TEXTS = {
  empty: 'Pole nie może być puste!',
  below_minimum: 'Data nie może być wcześniejsza niż data bieżąca',
  over_maximum: 'Wpisana liczba jest spoza zakresu 2099'
}

export const OPTIMIZE_DX_OPTIONS = {
  tableHeight: '100%',
  tableWidth: '100%',
  minTableHeight: 250,
  sideBarMargin: 425,
  columnNumberEditorOptions: {
    inputAttr: {maxLength: 5},
    step: 0,
    min: 0
  },
  columnNameEditorOptions: {maxLength: 80},
  columnPriceEditorOptions: {
    format: {
      type: 'fixedPoint',
      precision: 2
    },
    step: 0,
    min: 0
  },
  columnBarcodeEditorOptions: {maxLength: 13},
  columnGroupNumberEditorOptions: {
    inputAttr: {maxLength: 3},
    step: 0,
    min: 0
  },
  columnPackagingNumberEditorOptions: {
    inputAttr: {maxLength: 2},
    step: 0,
    min: 0
  },
  columnDiscountNumberEditorOptions: {
    inputAttr: {maxLength: 2},
    step: 0,
    min: 0
  },
  columnMinQuantityEditorOptions: {
    format: {
      type: 'fixedPoint',
      precision: 3
    },
    step: 0,
    min: 0
  },
  columnUiNumberEditorOptions: {
    inputAttr: {maxLength: 2},
    step: 0,
    min: 0
  },
  editorOptionsMaxLength4: {maxLength: 4},
  editorOptionsMaxLength16: {maxLength: 16},
  editorOptionsMaxLength20: {maxLength: 20},
  editorOptionsMaxLength24: {maxLength: 24},
  editorOptionsMaxLength25: {maxLength: 25},
  editorOptionsMaxLength32: {maxLength: 32},
  editorOptionsMaxLength35: {maxLength: 35},
  editorOptionsMaxLength38: {maxLength: 38},
  editorOptionsMaxLength40: {maxLength: 40},
  editorOptionsMaxLength60: {maxLength: 60},
  fixed_point_two: {
    type: 'fixedPoint',
    precision: 2
  },
  decimal_option: {
    type: 'decimal'
  },
  decimal_editor_option: {
    format: {type: 'decimal'}
  },
  fixed_point_three: {
    type: 'fixedPoint',
    precision: 3
  },
  price_editor_option: {
    format: {
      type: 'fixedPoint',
      precision: 2
    },
    step: 0,
    min: 0
  },
  onedigit_editor_option: {
    inputAttr: {
      maxLength: 1
    },
    step: 0,
    min: 0
  },
  twodigit_editor_option: {
    inputAttr: {
      maxLength: 2
    },
    step: 0,
    min: 0
  },
  threedigit_editor_option: {
    inputAttr: {
      maxLength: 3
    },
    step: 0,
    min: 0
  },
  fivedigit_editor_option: {
    inputAttr: {
      maxLength: 5
    },
    step: 0,
    min: 0
  },
  sixteendigit_editor_option: {
    inputAttr: {
      maxLength: 16
    },
    step: 0,
    min: 0
  },
  true_false: [
    {
      'id': 0,
      'text': 'Nie',
      'value': false
    }, {
      'id': 1,
      'text': 'Tak',
      'value': true
    }]
}

export const MENU_SIZES = {
  CLOSE: '50px',
  OPEN: '200px'
}

export const STATUSES = {
  main: null,
  mechanism: null,
  printer_queue_is_empty: false,
  actually_proceed_frame: null, // Buffer.from([]),
  actual_tokens_for_statuses: [],
  tasks_array_as_numbers: []
}

export const ICON_VALUES = {
  NONE: 0,
  INVALID: 1,
  DUPLICATE: 2,
  INVALID_AND_DUPLICATE: 3
}

export const STATUS_NAME = {
  DEFAULT: 0,
  PENDING: 1,
  SUCCESS: 2,
  FAIL: 3,
  NOT_CHECKED: 4
}

export const COLORS = {
  RGB: {
    BLACK: 0,
    WHITE: 765
  },
  BINARY: {
    BLACK: '1',
    WHITE: '0'
  }
}

export const BASE_NAME = {
  // towary/zestawy/multipaki
  PLU_ARTICLES: 'articles',
  PLU_SETS: 'sets',
  PLU_MULTIPACKS: 'multipacks',

  PLU_ADDITIONAL_CODES_ARTICLES: 'additional_codes_articles',
  PLU_ADDITIONAL_CODES_SETS: 'additional_codes_sets',
  PLU_ADDITIONAL_CODES_MULTIPACKS: 'additional_codes_multipacks',
  PLU_ARTICLES_IN_SETS: 'articles_in_sets',

  MEASUREMENT_UNITS: 'measurement_units',
  ITEMS_GROUPS: 'items_groups',
  PACKAGING: 'packaging',
  CLIENT_CARDS: 'client_cards',
  CODE_FORMATS: 'code_formats',
  PAYMENT_DESCRIPTION: 'payment_description',
  ARTICLES_DESCRIPTION: 'articles_description',
  ERROR_HANDLING: 'error_handling',
  DISCOUNTS: 'discounts',
  CASHIERS: 'cashiers',
  CASHIERS_PERMISSIONS: 'cashiers_permissions',
  PAYMENT_FORMS: 'payment_forms',
  SETS_OF_REPORTS: 'sets_of_reports',
  TIME_DISCOUNTS: 'time_discounts',
  NOTEPAD: 'notepad',
  SHORTCUT_KEYS: 'shortcut_keys',
  POSITION_RECEIPT_BUFFER: 'position_receipt_buffer'
}

export const BASES_TO_WATCH = {
  PLU_ARTICLES: BASE_NAME.PLU_ARTICLES,
  PLU_SETS: BASE_NAME.PLU_SETS,
  PLU_MULTIPACKS: BASE_NAME.PLU_MULTIPACKS,

  PLU_ADDITIONAL_CODES_ARTICLES: BASE_NAME.PLU_ADDITIONAL_CODES_ARTICLES,
  PLU_ADDITIONAL_CODES_SETS: BASE_NAME.PLU_ADDITIONAL_CODES_SETS,
  PLU_ADDITIONAL_CODES_MULTIPACKS: BASE_NAME.PLU_ADDITIONAL_CODES_MULTIPACKS,
  PLU_ARTICLES_IN_SETS: BASE_NAME.PLU_ARTICLES_IN_SETS,

  MEASUREMENT_UNITS: BASE_NAME.MEASUREMENT_UNITS,
  ITEMS_GROUPS: BASE_NAME.ITEMS_GROUPS,
  PACKAGING: BASE_NAME.PACKAGING,
  CLIENT_CARDS: BASE_NAME.CLIENT_CARDS,
  CODE_FORMATS: BASE_NAME.CODE_FORMATS,
  PAYMENT_DESCRIPTION: BASE_NAME.PAYMENT_DESCRIPTION,
  ARTICLES_DESCRIPTION: BASE_NAME.ARTICLES_DESCRIPTION,
  ERROR_HANDLING: BASE_NAME.ERROR_HANDLING,
  DISCOUNTS: BASE_NAME.DISCOUNTS,
  CASHIERS: BASE_NAME.CASHIERS,
  PAYMENT_FORMS: BASE_NAME.PAYMENT_FORMS,
  SETS_OF_REPORTS: BASE_NAME.SETS_OF_REPORTS,
  TIME_DISCOUNTS: BASE_NAME.TIME_DISCOUNTS,
  SHORTCUT_KEYS: BASE_NAME.SHORTCUT_KEYS
}

export const PLU_BASES = [
  BASE_NAME.PLU_ARTICLES,
  BASE_NAME.PLU_SETS,
  BASE_NAME.PLU_MULTIPACKS,
  BASE_NAME.PLU_ADDITIONAL_CODES_MULTIPACKS,
  BASE_NAME.PLU_ADDITIONAL_CODES_ARTICLES,
  BASE_NAME.PLU_ADDITIONAL_CODES_SETS,
  BASE_NAME.PLU_ARTICLES_IN_SETS
]

export const DUPLICATES_BASE_LABELS = {
  articles: 'Towary',
  sets: 'Zestawy',
  multipacks: 'Wielopaki',
  additional_codes_articles: 'Towary - kody dod.',
  additional_codes_sets: 'Zestawy - kody dod.',
  additional_codes_multipacks: 'Wielopaki - kody dod.'
}

export const ARTICLE_TYPE = {
  ARTICLE: 0,
  SET: 1,
  MULTIPACK: 3
}

export const VAT_RATES = {
  symbols: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
  types: {
    REGULAR: 1,
    INACTIVE: 2,
    EXEMPTED: 3
  },
  defaults: {
    A: {type: 1, rate: 23},
    B: {type: 1, rate: 8},
    C: {type: 1, rate: 5},
    D: {type: 1, rate: 0},
    E: {type: 3, rate: undefined},
    F: {type: 2, rate: undefined},
    G: {type: 2, rate: undefined}
  }
}

export const CARDS = {
  ARTICLE: 1,
  SET: 2,
  MULTIPACK: 3
}

export const QUILL_TAGS = {
  ENCODED: {
    STRONG: '&b',
    NEGATIVE: '&N',
    UNDER: '&u',
    ITALICS: '&i',
    HEIGHT: '&h',
    COMPANY: '&1',
    STREET: '&5',
    HOUSE: '&6',
    POST: '&4',
    APARTMENT: '&7',
    ZIP: '&2',
    CITY: '&3'
  },
  DECODED: {
    STRONG: 'strong',
    NEGATIVE: 'negative',
    UNDER: 'u',
    ITALICS: 'em',
    HEIGHT: 'height',
    COMPANY: 'company',
    STREET: 'street',
    HOUSE: 'house',
    POST: 'post',
    APARTMENT: 'apartment',
    ZIP: 'zip',
    CITY: 'city'
  },
  UNIQUE_FIELDS: {
    COMPANY: 'company',
    STREET: 'street',
    HOUSE: 'house',
    POST: 'post',
    APARTMENT: 'apartment',
    ZIP: 'zip',
    CITY: 'city'
  },
  TEXT_EDITING_PRINTER_ALIGN: {
    CENTER_ALIGN: '&c'
  },
  TEXT_EDITING_PRINTER_ALIGN_DECODED: {
    CENTER_ALIGN: 'p class="ql-align-center"'
  },
  TEXT_EDITING_PRINTER: {
    STRONG: '&b',
    NEGATIVE: '&N',
    UNDER: '&u',
    ITALICS: '&i',
    HEIGHT: '&h'
  },
  TEXT_EDITING_PRINTER_DECODED: {
    STRONG: 'strong',
    NEGATIVE: 'negative',
    UNDER: 'u',
    ITALICS: 'em',
    HEIGHT: 'height'
  },
  JPK_ENCODED: {
    COMPANY: '&1',
    STREET: '&5',
    HOUSE: '&6',
    POST: '&4',
    APARTMENT: '&7',
    ZIP: '&2',
    CITY: '&3'
  },
  JPK_DECODED: {
    COMPANY: 'company',
    STREET: 'street',
    HOUSE: 'house',
    POST: 'post',
    APARTMENT: 'apartment',
    ZIP: 'zip',
    CITY: 'city'
  }
}

export const DEEP_CARDS = {
  SETS: 1,
  ARTICLES_IN_SETS: 2
}

export const BASE_BUTTON_TEXTS = {
  delete_button_texts: {
    delete_selected: 'Usuń',
    delete: 'Usuń',
    delete_all: 'Usuń wszystkie'
  },
  send_button_texts: {
    send_selected: 'Wyślij wybrane',
    send: 'Wyślij',
    send_all: 'Wyślij wszystkie'
  }
}

export const ADDITIONAL_CODES = {
  [BASE_NAME.PLU_ARTICLES]: BASE_NAME.PLU_ADDITIONAL_CODES_ARTICLES,
  [BASE_NAME.PLU_SETS]: BASE_NAME.PLU_ADDITIONAL_CODES_SETS,
  [BASE_NAME.PLU_MULTIPACKS]: BASE_NAME.PLU_ADDITIONAL_CODES_MULTIPACKS
}

export const TYPE_OF_DISCOUNT = {
  STANDARD: 0,
  PROGRESSIVE: 1,
  PERCENTAGE: 2
}

export const LINKS = {
  PLU_ARTICLES: {
    to: '/base/plu_articles',
    label: 'PLU'
  },
  NOTEPAD: {
    to: '/base/notepad',
    label: 'Notatnik'
  },
  SETS_OF_REPORTS: {
    to: '/base/sets_of_reports',
    label: 'Zestawy raportów'
  },
  SHORTCUT_KEYS: {
    to: '/base/shortcut_keys',
    label: 'Klawisze skrótu'
  },
  ARTICLES_DESCRIPTION: {
    to: '/base/articles_description',
    label: 'Opisy towarów'
  },
  PACKAGING: {
    to: '/base/packaging',
    label: 'Opakowania'
  },
  MEASUREMENT_UNITS: {
    to: '/base/measurement_units',
    label: 'Jednostki miary'
  },
  ITEMS_GROUPS: {
    to: '/base/items_groups',
    label: 'Grupy towarowe'
  },
  PAYMENT_DESCRIPTION: {
    to: '/base/payment_description',
    label: 'Opisy wpłat/wypłat'
  },
  CASHIERS: {
    to: '/base/cashiers',
    label: 'Kasjerzy'
  },
  TIME_DISCOUNTS: {
    to: '/base/time_discounts',
    label: 'Rabaty czasowe'
  },
  ERROR_HANDLING: {
    to: '/base/error_handling',
    label: 'Obsługa błędów'
  },
  PAYMENT_FORMS: {
    to: '/base/payment_forms',
    label: 'Formy płatności'
  },
  CLIENT_CARDS: {
    to: '/base/client_cards',
    label: 'Karty klienta/rabatowe'
  },
  EMPTY: {
    to: '',
    label: ''
  },
  DISCOUNTS: {
    to: '/base/discounts',
    label: 'Rabaty/narzuty'
  },
  CODE_FORMATS: {
    to: '/base/code_formats',
    label: 'Formaty kodów ważonych'
  }
}

export const LINKS_FOR_READ = {
  [BASE_NAME.NOTEPAD]: LINKS.NOTEPAD.label,
  [BASE_NAME.SETS_OF_REPORTS]: LINKS.SETS_OF_REPORTS.label,
  [BASE_NAME.SHORTCUT_KEYS]: LINKS.SHORTCUT_KEYS.label,
  [BASE_NAME.ARTICLES_DESCRIPTION]: LINKS.ARTICLES_DESCRIPTION.label,
  [BASE_NAME.PACKAGING]: LINKS.PACKAGING.label,
  [BASE_NAME.MEASUREMENT_UNITS]: LINKS.MEASUREMENT_UNITS.label,
  [BASE_NAME.ITEMS_GROUPS]: LINKS.ITEMS_GROUPS.label,
  [BASE_NAME.PAYMENT_DESCRIPTION]: LINKS.PAYMENT_DESCRIPTION.label,
  [BASE_NAME.CASHIERS]: LINKS.CASHIERS.label,
  [BASE_NAME.TIME_DISCOUNTS]: LINKS.TIME_DISCOUNTS.label,
  [BASE_NAME.ERROR_HANDLING]: LINKS.ERROR_HANDLING.label,
  [BASE_NAME.PAYMENT_FORMS]: LINKS.PAYMENT_FORMS.label,
  [BASE_NAME.CLIENT_CARDS]: LINKS.CLIENT_CARDS.label,
  [BASE_NAME.DISCOUNTS]: LINKS.DISCOUNTS.label,
  [BASE_NAME.CODE_FORMATS]: LINKS.CODE_FORMATS.label
}
